// Top search

$(function () {
    $('.jsTopSearch-input').on('keyup focus', function () {
        if ($(this).val().length > 0) {
            $(this).next().find('.jsTopSearch-clear').removeClass('d-none');
        }
    }).on('keydown keyup blur', function () {
        if ($(this).val().length === 0) {
            $(this).next().find('.jsTopSearch-clear').addClass('d-none');
        }
    });

    $('.jsTopSearch-clear').on('click', function () {
        $(this).addClass('d-none');
        $('.jsTopSearch-input').val('');
    });

    $('.jsTopSearch-searchBtn').on('click', function () {
        $(this).addClass('d-none');
        $('.jsTopSearch-closeBtn').removeClass('d-none');
        $('.jsTopSearch-searchGroup').removeClass('d-none');
        $('.jsTopSearch-input').focus();
    });

    $('.jsTopSearch-closeBtn').on('click', function () {
        $(this).addClass('d-none');
        $('.jsTopSearch-searchBtn').removeClass('d-none');
        $('.jsTopSearch-searchGroup').addClass('d-none');
    });

    $('form.jsRegisterForm').on('submit', function (event) {
        event.preventDefault();
        $form = $(this);
        var $button = $form.find('button[type="submit"]');
        var $inputEmail = $form.find('.jsRegister-email');
        var $messageBox = $form.find('.jsRegister-message');
        var serviceUrl = $form.data('service') + '?email=' + $inputEmail.val();
        $messageBox.html('');
        $button.prop('disabled', true);
        $.post(serviceUrl, function (data) {
            if (data.IsSuccess == true) {
                $inputEmail.val('');
                $messageBox.html('<p class="bg-green text-white p-2">' + data.Message + '</p>');
            } else {
                $messageBox.html('<p class="bg-red text-white p-2">' + data.Message + '</p>');
            }
            $button.prop('disabled', false);
        });
    });

    var $signIn = $('.jsSignin');
    var $signUp = $('.jsSignup');
    var $signUpButton = $('.jsSignupButton');
    var $signInDropdown = $('.jsSigninDropdown');
    var $signUpGoBackButton = $(".jsSignUpGoBackButton");

    $signUp.hide();
    $signUpButton.on('click', function () {
        $signUp.show();
        $signIn.hide();
    });
    $signInDropdown.on('click', function(e){
        e.stopPropagation();
    });

    $signUpGoBackButton.click(function(e){
        e.preventDefault();
        $signUp.hide();
        $signIn.show();
    });

});
